import { createRoutine } from 'redux-saga-routines';
import { createAction } from 'redux-actions';
import { RETRIEVE_ME, SET_ME } from './types';

export const setMe = createAction(SET_ME);
export const retrieveMe = createRoutine(RETRIEVE_ME);
